module.exports = __webpack_public_path__ + "img/elandon_roberts.ed74472f.png";